import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy container">
      <h1>Privacy Policy</h1>

      <section>
        <h2>1. General Information</h2>
        <p>This document describes how the <strong>Control Ball</strong> app, published by <strong>OM-GAMES</strong>, handles user privacy.</p>
      </section>

      <section>
        <h2>2. Data Collection</h2>
        <p>The <strong>Control Ball</strong> app does not collect, store, or share any personal user information.</p>
      </section>

      <section>
        <h2>3. Advertising</h2>
        <p>The app displays ads provided by <strong>Google AdMob</strong>. AdMob may collect and use certain data to serve personalized ads. For more information, please refer to the <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a>.</p>
      </section>

      <section>
        <h2>4. Data Sharing</h2>
        <p>The <strong>Control Ball</strong> app does not share any user data with third parties.</p>
      </section>

      <section>
        <h2>5. Third-Party Services</h2>
        <p>The app <strong>does not use third-party services</strong> such as Firebase, PlayFab, or other external platforms to collect or store information.</p>
      </section>

      <section>
        <h2>6. In-App Purchases</h2>
        <p>The <strong>Control Ball</strong> app does not offer any in-app purchases.</p>
      </section>

      <section>
        <h2>7. Target Audience</h2>
        <p>The app is intended for a <strong>general audience</strong> and can be used by all ages.</p>
      </section>

      <section>
        <h2>8. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. Any changes will be published on this page.</p>
      </section>

      <section>
        <h2>9. Contact</h2>
        <p>If you have any questions regarding this Privacy Policy, please contact us at: <strong>otaviomartinslima@gmail.com</strong>.</p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
